  
export function getLayer(layer,id) {
  
  return layer.filter(function(l){ return l.id === id} )[0]
}


  